import {SynapiTaxonomy} from "./SynapiTaxonomy";

export class SynapiFilters extends SynapiTaxonomy{
    Categorie?: any;
    Categories?: any;
    operator?: '_'|'∩';
    override Children: SynapiFilters[];
    CriteriaTrees: SynapiFilters[];
    constructor(){
      super();
      this.CriteriaTrees = [];
    }
}
